var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.doctor)?_c('div',{staticClass:"mb-6 mt-6"},[_c('card-title',{attrs:{"title":'Localisation du cabinet',"icon":'mdi-google-maps'}}),_c('maps-doctor',{attrs:{"marker_doctor":_vm.doctor.marker},on:{"markerSaved":_vm.markerSaved}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }